export class StakeholderReponseDto {
  id: string;
  PipelineId: string;
  StakeholderId: string;
  StakeholderName: string;
  StakeholderRepId: string;
  StakeholderRepName: string;
  PLActivityId: string;
  Response: string;
  PipelineLicenseRequestId: string;
  DocumentId: string;
  Version: number;
  CreatedAt: Date;
  UpdatedAt: Date;

  //   constructor() {
  //     this.id = Guid.create().toString();
  //   }
}
